(function () {
  if (customElements.get('pdm-sticky-atc')) return;

  class PdmStickyAtc extends HTMLElement {
    connectedCallback() {
      if (this.parentElement !== document.body) {
        document.body.appendChild(this);
        return;
      }

      if (this._shouldInitialize()) {
        this._initialize();
        return;
      }

      var self = this;
      this._flagsReadyHandler = function () {
        if (self._shouldInitialize()) {
          window.removeEventListener('pdm:feature-flags-ready', self._flagsReadyHandler);
          self._flagsReadyHandler = null;
          self._initialize();
        }
      };
      window.addEventListener('pdm:feature-flags-ready', this._flagsReadyHandler);
    }

    disconnectedCallback() {
      if (this._observer) this._observer.disconnect();
      if (this._widgetObserver) this._widgetObserver.disconnect();
      if (this._flagsReadyHandler) {
        window.removeEventListener('pdm:feature-flags-ready', this._flagsReadyHandler);
        this._flagsReadyHandler = null;
      }
      if (this._variantResizeHandler) {
        window.removeEventListener('resize', this._variantResizeHandler);
        this._variantResizeHandler = null;
      }
    }

    _shouldInitialize() {
      return window.innerWidth >= 750
        && document.body.hasAttribute('data-desktop-sticky-atc');
    }

    _initialize() {
      if (this._initialized) return;
      this._initialized = true;

      this.productId = this.dataset.productId;
      this.hasSubscription = this.dataset.hasSubscription === 'true';
      this.forceOos = this.dataset.forceOos === 'true';
      this.textAddToCart = this.dataset.tAddToCart;
      this.textSoldOut = this.dataset.tSoldOut;

      this.minimizeChip = this.querySelector('[data-pdm-minimize-chip]');
      this.imageEl = this.querySelector('[data-pdm-image]');
      this.inner = this.querySelector('.pdm-sticky-atc__inner');
      this.variantButtons = Array.prototype.slice.call(this.querySelectorAll('[data-pdm-variant-chip]'));
      this.variantSelects = Array.prototype.slice.call(this.querySelectorAll('[data-pdm-variant-select]'));
      this.subCheckbox = this.querySelector('[data-pdm-sub-checkbox]');
      this.freqCol = this.querySelector('[data-pdm-freq-col]');
      this.freqSelect = this.querySelector('[data-pdm-freq-select]');
      this.priceCurrentEl = this.querySelector('[data-pdm-price-current]');
      this.priceOriginalEl = this.querySelector('[data-pdm-price-original]');
      this.atcButton = this.querySelector('[data-pdm-atc]');

      var jsonEl = document.getElementById('ProductJson-' + this.productId);
      this.productData = jsonEl ? JSON.parse(jsonEl.textContent) : null;

      var mainInput = document.querySelector('.group-product__form input[name="id"]');
      var initialVariant = mainInput ? this._findVariantById(parseInt(mainInput.value, 10)) : null;
      if (initialVariant) this._renderVariantState(initialVariant);

      this._bindVariantEvents();
      this._bindSubscriptionEvents();
      this._bindAtcButton();
      this._bindMinimizeChip();
      this._setupIntersectionObserver();
      this._setupWidgetInjectionObserver();
      this._setupVariantLayout();
    }

    _findVariantById(id) {
      if (!this.productData || !id) return null;
      return this.productData.variants.find(function (v) { return v.id === id; });
    }

    _syncVariantOptions(variant) {
      if (!variant) return;

      this.variantButtons.forEach(function (btn) {
        var pos = btn.dataset.optionPosition;
        var value = btn.dataset.optionValue;
        var optionKey = 'option' + pos;
        var isActive = variant[optionKey] === value;

        var mainChip = document.querySelector(
          '.product-variants-options .variant-option-chip[data-option-position="' + pos + '"][data-option-value="' + CSS.escape(value) + '"]'
        );
        var isUnavailable = mainChip ? mainChip.classList.contains('is-unavailable') : false;

        btn.classList.toggle('pdm-sticky-atc__variant-chip--active', isActive);
        btn.classList.toggle('pdm-sticky-atc__variant-chip--unavailable', isUnavailable);
      });

      // Keep the collapsible-option dropdowns in lockstep with the chips.
      this.variantSelects.forEach(function (select) {
        var pos = select.dataset.optionPosition;
        var optionKey = 'option' + pos;
        var current = variant[optionKey];
        Array.prototype.forEach.call(select.options, function (opt) {
          var mainChip = document.querySelector(
            '.product-variants-options .variant-option-chip[data-option-position="' + pos + '"][data-option-value="' + CSS.escape(opt.value) + '"]'
          );
          opt.disabled = mainChip ? mainChip.classList.contains('is-unavailable') : false;
        });
        if (current != null) select.value = current;
      });
    }

    _renderVariantState(variant) {
      if (!variant) return;
      this.currentVariant = variant;

      this._syncVariantOptions(variant);

      this._renderImage(variant);
      this._renderPrice();
      this._renderFrequencyOptions(variant);
      this._renderAtcAvailability(variant);

      var self = this;
      // The PDP recomputes chip availability (updateOptionAvailability) AFTER it
      // dispatches 'variantChanged', so the availability we mirrored above can be
      // stale on multi-option products (e.g. the combo-flavor path) — which left
      // sticky chips/dropdowns wrongly disabled. Re-sync on later ticks, once the
      // PDP has settled, so the sticky matches the main PDP's real availability.
      setTimeout(function () { self._syncVariantOptions(self.currentVariant); }, 0);
      setTimeout(function () { self._syncVariantOptions(self.currentVariant); }, 200);

      if (this.hasSubscription && this.freqSelect) {
        setTimeout(function () { self._alignFreqFromMainForm(); }, 200);
      }
    }

    _renderImage(variant) {
      if (!this.imageEl) return;
      if (this.imageEl.dataset.pdmImageLocked === 'true') return;
      var src = variant.featured_image ? variant.featured_image.src : null;
      if (src) this.imageEl.src = src;
    }

    _renderPrice() {
      var priceContainer = document.querySelector('.product-price');
      if (!priceContainer || !this.priceCurrentEl) return;

      var basePrice = parseInt(priceContainer.dataset.basePrice || '0', 10);
      var compareAtPrice = parseInt(priceContainer.dataset.compareAtPrice || '0', 10);
      var discountedPrice = parseInt(priceContainer.dataset.discountedPrice || '0', 10);
      var isSubscribed = this.hasSubscription && this._isSubscribed();

      if (isSubscribed) {
        this.priceCurrentEl.textContent = this._formatMoney(discountedPrice);
        if (this.priceOriginalEl) {
          this.priceOriginalEl.textContent = this._formatMoney(basePrice);
          this.priceOriginalEl.classList.toggle('pdm-sticky-atc__price-original--visible', discountedPrice < basePrice);
        }
      } else {
        this.priceCurrentEl.textContent = this._formatMoney(basePrice);
        if (this.priceOriginalEl) {
          if (compareAtPrice > basePrice) {
            this.priceOriginalEl.textContent = this._formatMoney(compareAtPrice);
            this.priceOriginalEl.classList.add('pdm-sticky-atc__price-original--visible');
          } else {
            this.priceOriginalEl.classList.remove('pdm-sticky-atc__price-original--visible');
          }
        }
      }
    }

    _formatMoney(cents) {
      if (window.Shopify && Shopify.formatMoney) {
        return Shopify.formatMoney(cents, Shopify.money_format);
      }
      return '$' + (cents / 100).toFixed(2);
    }

    _getPlanNamesMap() {
      if (this._planNamesMap) return this._planNamesMap;
      var map = {};
      var groups = (this.productData && this.productData.selling_plan_groups) || [];
      groups.forEach(function (group) {
        (group.selling_plans || []).forEach(function (plan) {
          if (plan && plan.id != null) map[plan.id] = plan.name;
        });
      });
      this._planNamesMap = map;
      return map;
    }

    _allocPlanId(alloc) {
      if (!alloc) return null;
      if (alloc.selling_plan && alloc.selling_plan.id != null) return alloc.selling_plan.id;
      if (alloc.selling_plan_id != null) return alloc.selling_plan_id;
      return null;
    }

    _renderFrequencyOptions(variant) {
      if (!this.freqSelect) return;
      var allocations = variant.selling_plan_allocations || [];
      var previousValue = this.freqSelect.value;
      var planNames = this._getPlanNamesMap();
      var self = this;

      this.freqSelect.innerHTML = '';
      allocations.forEach(function (alloc) {
        var planId = self._allocPlanId(alloc);
        if (planId == null) return;
        var name = (alloc.selling_plan && alloc.selling_plan.name) || planNames[planId] || ('Plan ' + planId);
        name = String(name).split('with')[0].replace(/^\s*delivery\s+/i, '').trim();
        var option = document.createElement('option');
        option.value = planId;
        option.textContent = name;
        self.freqSelect.appendChild(option);
      });

      var stillExists = Array.prototype.some.call(this.freqSelect.options, function (opt) {
        return opt.value === previousValue;
      });
      if (stillExists) this.freqSelect.value = previousValue;
    }

    _renderAtcAvailability(variant) {
      if (!this.atcButton) return;
      var soldOut = this.forceOos || !variant.available;
      this.atcButton.disabled = soldOut;
      this.atcButton.textContent = soldOut ? this.textSoldOut : this.textAddToCart;
    }

    _alignFreqFromMainForm() {
      if (!this.freqSelect) return;
      var selectedOption = document.querySelector(
        '.subscription-state .custom-option.selected, .subscription-dropdown .custom-option.selected'
      );
      if (!selectedOption) return;
      var value = String(selectedOption.dataset.value || '');
      if (!value) return;
      var hasOption = Array.prototype.some.call(this.freqSelect.options, function (opt) {
        return String(opt.value) === value;
      });
      if (hasOption && this.freqSelect.value !== value) {
        this.freqSelect.value = value;
      }
    }

    _whenMainCustomOptionReady(callback, timeoutMs) {
      var sel = '.subscription-state .custom-option, .subscription-dropdown .custom-option';
      var existing = document.querySelector(sel);
      if (existing) { callback(existing); return; }
      var fired = false;
      var observer = new MutationObserver(function () {
        var el = document.querySelector(sel);
        if (el && !fired) {
          fired = true;
          observer.disconnect();
          callback(el);
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });
      setTimeout(function () { observer.disconnect(); }, timeoutMs || 10000);
    }

    _bindVariantEvents() {
      var self = this;

      this.variantButtons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (btn.classList.contains('pdm-sticky-atc__variant-chip--unavailable')) return;

          var pos = btn.dataset.optionPosition;
          var value = btn.dataset.optionValue;

          var mainChip = document.querySelector(
            '.product-variants-options .variant-option-chip[data-option-position="' + pos + '"][data-option-value="' + CSS.escape(value) + '"]'
          );
          if (mainChip && !mainChip.disabled) mainChip.click();
        });
      });

      // Collapsible-option dropdowns use the same sync path as the chips:
      // a change just clicks the matching (hidden) main-form chip.
      this.variantSelects.forEach(function (select) {
        select.addEventListener('change', function () {
          var pos = select.dataset.optionPosition;
          var value = select.value;

          var mainChip = document.querySelector(
            '.product-variants-options .variant-option-chip[data-option-position="' + pos + '"][data-option-value="' + CSS.escape(value) + '"]'
          );
          if (mainChip && !mainChip.disabled) mainChip.click();
        });
      });

      document.addEventListener('variantChanged', function (e) {
        self._renderVariantState(e.detail.variant);
      });
    }

    _bindSubscriptionEvents() {
      if (!this.hasSubscription) return;
      var self = this;

      if (this.subCheckbox) {
        this.subCheckbox.addEventListener('change', function () {
          self._forwardToggleToMainForm(self.subCheckbox.checked);
          self._applySubscriptionUiState(self.subCheckbox.checked);
        });
      }

      if (this.freqSelect) {
        this.freqSelect.addEventListener('change', function () {
          var value = String(self.freqSelect.value);
          var allOptions = document.querySelectorAll('.custom-option');
          allOptions.forEach(function (opt) { opt.classList.remove('selected'); });
          var matching = document.querySelectorAll(
            '.custom-option[data-value="' + value + '"]'
          );
          matching.forEach(function (opt) { opt.classList.add('selected'); });
          var rechargeDropdown = document.querySelector('.rc-selling-plans__dropdown');
          if (rechargeDropdown) rechargeDropdown.value = value;
        });
      }

      ['subToggle', 'subToggle2'].forEach(function (id) {
        var mainToggle = document.getElementById(id);
        if (!mainToggle) return;
        mainToggle.addEventListener('change', function () {
          if (self.subCheckbox && self.subCheckbox.checked !== mainToggle.checked) {
            self.subCheckbox.checked = mainToggle.checked;
          }
          self._applySubscriptionUiState(mainToggle.checked);
        });
      });

      document.addEventListener('click', function (e) {
        if (!e.target || typeof e.target.closest !== 'function') return;
        var opt = e.target.closest('.subscription-state .custom-option, .subscription-dropdown .custom-option');
        if (!opt) return;
        setTimeout(function () { self._alignFreqFromMainForm(); }, 0);
      });

      this._syncFromMainToggle();
      setTimeout(function () { self._syncFromMainToggle(); }, 700);

      this._whenMainCustomOptionReady(function () {
        self._alignFreqFromMainForm();
      });
    }

    _forwardToggleToMainForm(checked) {
      var mainToggle = document.getElementById('subToggle') || document.getElementById('subToggle2');
      if (!mainToggle) return;
      if (mainToggle.checked !== checked) {
        mainToggle.checked = checked;
        mainToggle.dispatchEvent(new Event('change'));
      }
    }

    _syncFromMainToggle() {
      var mainToggle = document.getElementById('subToggle') || document.getElementById('subToggle2');
      if (!mainToggle || !this.subCheckbox) return;
      this.subCheckbox.checked = mainToggle.checked;
      this._applySubscriptionUiState(mainToggle.checked);
    }

    _applySubscriptionUiState(checked) {
      if (this.freqCol) this.freqCol.classList.toggle('pdm-sticky-atc__freq-col--expanded', checked);
      this._renderPrice();
    }

    _isSubscribed() {
      return !!(this.subCheckbox && this.subCheckbox.checked);
    }

    _bindAtcButton() {
      var self = this;
      if (!this.atcButton) return;
      this.atcButton.addEventListener('click', function () {
        if (self.atcButton.disabled) return;
        var buttons = document.querySelectorAll('.group-product__form-wrapper .primary-button.pdm-btn');
        var target = null;
        for (var i = 0; i < buttons.length; i++) {
          var rect = buttons[i].getBoundingClientRect();
          if (rect.width > 0 && rect.height > 0) { target = buttons[i]; break; }
        }
        if (!target && buttons.length > 0) target = buttons[0];
        if (target) target.click();
      });
    }

    _bindMinimizeChip() {
      var self = this;
      if (!this.minimizeChip) return;
      this.minimizeChip.addEventListener('click', function () {
        var minimized = self.classList.toggle('pdm-sticky-atc--minimized');
        self.minimizeChip.setAttribute('aria-expanded', String(!minimized));
        self._updateFixedWidgetsBottom();
      });
    }

    _updateFixedWidgetsBottom() {
      var eligible = this.classList.contains('pdm-sticky-atc--eligible');
      var minimized = this.classList.contains('pdm-sticky-atc--minimized');
      var basePx = eligible ? (minimized ? 20 : 90) : null;
      var widgets = [
        { selector: 'iframe#chat-button', extraPx: 0 },
        { selector: '.userway_buttons_wrapper', extraPx: 5 }
      ];
      widgets.forEach(function (w) {
        var el = document.querySelector(w.selector);
        if (!el) return;
        if (basePx != null) {
          el.style.setProperty('bottom', (basePx + w.extraPx) + 'px', 'important');
        } else {
          el.style.removeProperty('bottom');
        }
      });
    }

    _setupIntersectionObserver() {
      if (!('IntersectionObserver' in window)) return;
      var self = this;

      var target = document.querySelector('.group-product__form');
      if (!target) {
        console.warn('[pdm-sticky-atc] observer target .group-product__form not found');
        self.setAttribute('data-pdm-observer', 'no-target');
        return;
      }

      self.setAttribute('data-pdm-observer', 'group-product__form');
      self.setAttribute('data-pdm-eligible', 'false');

      this._observer = new IntersectionObserver(function (entries) {
        var eligible = !entries[0].isIntersecting;
        self.classList.toggle('pdm-sticky-atc--eligible', eligible);
        self.setAttribute('data-pdm-eligible', String(eligible));
        self._updateFixedWidgetsBottom();
        if (eligible) self._updateVariantLayout();
      }, { threshold: 0 });

      this._observer.observe(target);
    }

    // Collapse the chips of 3+ value options into dropdowns only when they
    // would crowd the title. Runs once now, on eligibility, and on resize.
    _setupVariantLayout() {
      if (!this.variantSelects || this.variantSelects.length === 0) return;
      var self = this;
      var t;
      this._variantResizeHandler = function () {
        clearTimeout(t);
        t = setTimeout(function () { self._updateVariantLayout(); }, 100);
      };
      window.addEventListener('resize', this._variantResizeHandler);
      this._updateVariantLayout();
    }

    _updateVariantLayout() {
      if (!this.inner || !this.variantSelects || this.variantSelects.length === 0) return;
      // Can't measure a collapsed (max-height:0) or unrendered bar.
      if (this.inner.clientWidth === 0) return;
      // Measure with chips shown, then decide.
      this.classList.remove('pdm-sticky-atc--variants-collapsed');
      // Force reflow so scrollWidth reflects the chips layout.
      var overflow = this.inner.scrollWidth > this.inner.clientWidth + 1;
      this.classList.toggle('pdm-sticky-atc--variants-collapsed', overflow);
    }

    _setupWidgetInjectionObserver() {
      var self = this;
      var selectors = ['iframe#chat-button', '.userway_buttons_wrapper'];
      var found = {};

      var check = function () {
        var missing = false;
        selectors.forEach(function (sel) {
          if (found[sel]) return;
          if (document.querySelector(sel)) {
            found[sel] = true;
          } else {
            missing = true;
          }
        });
        self._updateFixedWidgetsBottom();
        return !missing;
      };

      if (check()) return;

      this._widgetObserver = new MutationObserver(function () {
        if (check()) {
          self._widgetObserver.disconnect();
          self._widgetObserver = null;
        }
      });
      this._widgetObserver.observe(document.body, { childList: true, subtree: true });

      setTimeout(function () {
        if (self._widgetObserver) {
          self._widgetObserver.disconnect();
          self._widgetObserver = null;
        }
      }, 30000);
    }
  }

  customElements.define('pdm-sticky-atc', PdmStickyAtc);
})();
